// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__PooGD","errorLogs":"styles_errorLogs__3T-D6"};